import * as React from "react";
import styled from "@mui/material/styles/styled";
import { MobileHorizontalScrollMenu } from "../common/mobileHorizontalScrollMenu";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";
import { Button, Theme } from "@mui/material";
import { MobileView } from "../../../util/aKaunGeneralUtil";

//region [[ Styles ]]
const SubCategoryMenuView = styled(MobileHorizontalScrollMenu)({
  margin: 0,
  width: "calc(100% - 7px)",
  height: "auto",
  "& .scroll-menu-container": {
    paddingBottom: "8px",
    paddingTop: "8px",
    marginBottom: 0,
  },
});

enum ColorModes {
  invert,
  regular,
}

type MenuItemProps = {
  theme?: Theme;
  selected: "selected" | "clear";
  colors: ColorModes;
};

const MenuItemColors = {
  [ColorModes.invert]: {
    text: {
      selected: KahunColorMap.White,
      clear: KahunColorMap.PrimaryDim,
    },
    background: {
      selected: KahunColorMap.PrimaryDim,
      clear: "transparent",
    },
  },
  [ColorModes.regular]: {
    text: {
      selected: KahunColorMap.PrimaryDim,
      clear: KahunColorMap.White,
    },
    background: {
      selected: KahunColorMap.White,
      clear: "transparent",
    },
  },
};
const MenuItem = styled(Button)(
  ({ theme, selected, colors }: MenuItemProps) => ({
    cursor: "pointer",
    fontSize: "14px",
    lineHeight: "19px",
    fontWeight: 500,
    color: MenuItemColors[colors]["text"][selected],
    background: MenuItemColors[colors]["background"][selected],
    transition: "all 0.1s ease-in",
    borderRadius: "33px",
    padding: "0 19px",
    minWidth: "auto",
    width: "auto",
    textTransform: "none",
    "&:hover": {
      background: MenuItemColors[colors]["background"]["selected"],
      color: MenuItemColors[colors]["text"]["selected"],
      opacity: 0.8,
      [theme.breakpoints.down(MobileView)]: {
        // Don't change color on hover in mobile as it turns out weird
        background: MenuItemColors[colors]["background"][selected],
        color: MenuItemColors[colors]["text"][selected],
        opacity: 1,
      },
    },
    "&:not(:last-of-type)": {
      marginRight: "15px",
    },
  }),
);

//endregion [[ Styles ]]

//region [[ Props ]]
export interface SubGroup {
  id: string;
  name: string;
}

interface PanelsSubCategoryMenuProps {
  className?: string;
  subGroups: SubGroup[];
  selection: string;
  onSelect: (sg: SubGroup) => void;
  invertColors?: boolean;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const PanelsSubGroupMenu = ({
  ...props
}: PanelsSubCategoryMenuProps) => {
  const { subGroups, onSelect, selection } = props;

  const clickHandler = React.useCallback(
    (subGroup: any) => () => onSelect(subGroup),
    [onSelect],
  );

  return (
    <SubCategoryMenuView
      className={props.className}
      fadeToColor={
        props.invertColors ? KahunColorMap.White : KahunColorMap.PrimaryDim
      }
    >
      {subGroups.map((sg) => (
        <MenuItem
          key={sg.id}
          selected={selection === sg.id ? "selected" : "clear"}
          onClick={clickHandler(sg)}
          className={"menu-item"}
          colors={props.invertColors ? ColorModes.invert : ColorModes.regular}
        >
          {sg.name === "Habits" ? "Risk Factors" : sg.name}
        </MenuItem>
      ))}
    </SubCategoryMenuView>
  );
};
